import styled from "styled-components";

const ProductLink = styled.span`
    margin-bottom: 5px;
    font-size: 16px;
    color: inherit;
    transition: color 0.12s ease-out 0s;
    display: block;
    max-width: 100%;
    word-wrap: break-word;
    line-height: 1.4;
    cursor: pointer;
    color: #222;
    text-decoration: none !important;
    display: block;
    padding-right: 45px;

    &:hover {
        color: #222;
    }
`;
export default ProductLink;
